import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export default function ModalVoltar(props) {
    return (
        <div className="modal-fundo">
            <div className="modal2">
                <div className="modal-titulo">
                    <FiAlertCircle size={88} />
                    <p>PROPOSTA NÃO SALVA!</p>
                </div>
                <div className="modal-conteudo">
                    <p>
                        Suas alterações não foram salvas. Qualquer informação inserida será perdida!
                    </p>
                    <br/>
                    <p>
                        Deseja proseguir com essa ação?
                    </p>
                    <br/>
                    <br/>
                </div>
                <div className="modal-acao">
                    <button className="modal-botao" onClick={(e) => props.setModalVoltarAberto(false)}>
                        Cancelar
                    </button>
                    <button className="modal-botao" onClick={(e) => {props.voltar(); props.setModalVoltarAberto(false);}}>
                        Sair sem salvar
                    </button>
                </div>
            </div>
        </div>
    );
}